module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/rainbow-9ca0251d3125f819845ebe0870b8a1de.svg";